import React from 'react';

const GenderSelector = ({ selectedGender, onGenderChange }) => {
    // Gender options matching Django backend GenderOptions
    const genderOptions = [
        {
            value: 'MALE',
            label: 'Male',
            icon: '👨'
        },
        {
            value: 'FEMALE',
            label: 'Female',
            icon: '👩'
        },
        {
            value: 'OTHER',
            label: 'Other',
            icon: '🏳️‍⚧️'
        },
        {
            value: 'PREFER_NOT_TO_SAY',
            label: 'Prefer not to say',
            icon: '🤐'
        }
    ];

    const handleGenderSelect = (genderValue) => {
        onGenderChange(genderValue);
    };

    return (
        <div className="space-y-3">
            <label className="text-sm font-medium text-accent-700">
                Gender (Optional)
            </label>

            <div className="grid grid-cols-2 gap-3">
                {genderOptions.map((option) => (
                    <button
                        key={option.value}
                        onClick={() => handleGenderSelect(option.value)}
                        className={`
                            relative p-4 rounded-lg border-2 transition-all duration-200
                            hover:border-primary-300 hover:shadow-md
                            ${selectedGender === option.value
                                ? 'border-primary-600 bg-primary-50 shadow-md'
                                : 'border-accent-200 bg-white'
                            }
                        `}
                        type="button"
                    >
                        <div className="flex flex-col items-center space-y-2">
                            <span className="text-2xl">{option.icon}</span>
                            <span className={`
                                text-sm font-medium
                                ${selectedGender === option.value
                                    ? 'text-primary-700'
                                    : 'text-accent-600'
                                }
                            `}>
                                {option.label}
                            </span>
                        </div>

                        {/* Selection indicator */}
                        {selectedGender === option.value && (
                            <div className="absolute -top-2 -right-2 w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center">
                                <span className="text-white text-xs">✓</span>
                            </div>
                        )}
                    </button>
                ))}
            </div>

            <div className="text-xs text-accent-500">
                This helps us personalize gift recommendations for you and your loved ones.
            </div>
        </div>
    );
};

export default GenderSelector; 